"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../../theme"));
var _ValidationMessage = _interopRequireDefault(require("../../components/Field/ValidationMessage"));
var _styledComponents = require("./styled-components");
var _Stack = _interopRequireDefault(require("../../components/Stack"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Field = function Field(_ref) {
  var children = _ref.children,
    helperText = _ref.helperText,
    labelText = _ref.labelText,
    name = _ref.name,
    touched = _ref.touched,
    validationMessage = _ref.validationMessage,
    ValidationComponent = _ref.ValidationComponent,
    warningMessage = _ref.warningMessage,
    ariaErrorMessageId = _ref.ariaErrorMessageId;
  var showError = touched && !!validationMessage;
  var showWarning = !showError && touched && !!warningMessage;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.FieldWrapper, null, !!labelText && /*#__PURE__*/_react["default"].createElement(_styledComponents.Label, {
    hasHelperText: !!helperText,
    htmlFor: name
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.LabelText, null, labelText, ' ', showError && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: _theme["default"].errorDark
    }
  }, "*"))), !!helperText && /*#__PURE__*/_react["default"].createElement(_styledComponents.HelperText, null, helperText), /*#__PURE__*/_react["default"].createElement(_Stack["default"], {
    space: "space10",
    direction: "column"
  }, children, showWarning && !ValidationComponent && /*#__PURE__*/_react["default"].createElement(_ValidationMessage["default"], {
    id: ariaErrorMessageId,
    message: warningMessage,
    variant: "warning"
  }), showError && !ValidationComponent && /*#__PURE__*/_react["default"].createElement(_ValidationMessage["default"], {
    id: ariaErrorMessageId,
    message: validationMessage,
    variant: "error"
  }), (showError || showWarning) && !!ValidationComponent && /*#__PURE__*/_react["default"].createElement(ValidationComponent, {
    message: validationMessage || warningMessage,
    id: ariaErrorMessageId,
    variant: showError ? 'error' : 'warning'
  })));
};
Field.propTypes = {
  children: _propTypes["default"].node.isRequired,
  helperText: _propTypes["default"].node,
  labelText: _propTypes["default"].string,
  name: _propTypes["default"].string,
  touched: _propTypes["default"].bool,
  validationMessage: _propTypes["default"].string,
  ValidationComponent: _propTypes["default"].elementType,
  warningMessage: _propTypes["default"].string,
  ariaErrorMessageId: _propTypes["default"].string
};
var _default = exports["default"] = Field;